import { history } from 'instantsearch.js/es/lib/routers';
import { singleIndex } from 'instantsearch.js/es/lib/stateMappings';

export function setupRouting(indexName) {
    return {
        router: history(),
        stateMapping: {
            stateToRoute(uiState) {
                const mapper = singleIndex(indexName);
                const route = mapper.stateToRoute(uiState);
                if (route.query) {
                    route.q = route.query;
                    delete route.query;
                }
                return route;
            },
            routeToState(routeState) {
                const mapper = singleIndex(indexName);
                const params = new URLSearchParams(window.location.search);
                const q = params.get('q') || routeState.q;
                if (q) {
                    routeState.query = q;
                }
                return mapper.routeToState(routeState);
            },
        },
    };
}

export function setupSuggestionsRouting(indexName, isEnabledFn) {
    const base = setupRouting(indexName);
    const router = base.router;

    return {
        router: {
            read: () => (typeof router.read === 'function' ? router.read() : {}),
            write: (routeState) => {
                if (isEnabledFn() && typeof router.write === 'function') {
                    router.write(routeState);
                }
            },
            push: (routeState) => {
                if (isEnabledFn() && typeof router.push === 'function') {
                    router.push(routeState);
                }
            },
            onUpdate: (cb) => {
                if (typeof router.onUpdate === 'function') {
                    return router.onUpdate((routeState) => {
                        if (isEnabledFn()) cb(routeState);
                    });
                }
            },
            createURL: (routeState) =>
                typeof router.createURL === 'function' ? router.createURL(routeState) : '',
            dispose: () => {
                if (typeof router.dispose === 'function') {
                    router.dispose();
                }
            },
        },
        stateMapping: {
            stateToRoute(uiState) {
                const standardRoute = base.stateMapping.stateToRoute(uiState);
                const prefixedRoute = {};

                for (const key in standardRoute) {
                    if (key === 'q') {
                        prefixedRoute.sq = standardRoute[key];
                    } else {
                        prefixedRoute[`s_${key}`] = standardRoute[key];
                    }
                }

                return prefixedRoute;
            },
            routeToState(routeState) {
                const mapper = singleIndex(indexName);
                const unprefixedRoute = {};

                for (const key in routeState) {
                    if (key === 'sq') {
                        unprefixedRoute.query = routeState[key];
                    } else if (key.startsWith('s_')) {
                        unprefixedRoute[key.substring(2)] = routeState[key];
                    }
                }

                // Handle initial page load parsing for 'sq' directly from URL params
                const params = new URLSearchParams(window.location.search);
                const sq = params.get('sq') || unprefixedRoute.query;

                if (sq) {
                    unprefixedRoute.query = sq;
                }

                return mapper.routeToState(unprefixedRoute);
            },
        },
    };
}
